import type { Resource } from '../../';
export const cart_errors_cartTotalQuantityExceeded: Resource = {"default":"We're sorry, but you have exceeded the maximum quantity allowed."};
